import { render } from "./UserTasksView.vue?vue&type=template&id=7caf65ce&scoped=true"
import script from "./UserTasksView.vue?vue&type=script&lang=js"
export * from "./UserTasksView.vue?vue&type=script&lang=js"

import "./UserTasksView.vue?vue&type=style&index=0&id=7caf65ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7caf65ce"]])

export default __exports__